(function () {
  function bind(input) {
    const listId = input.getAttribute('data-facet-search-target');
    if (!listId) return;
    const list = document.getElementById(listId);
    if (!list) return;

    input.addEventListener('input', () => {
      const q = input.value.trim().toLowerCase();
      list.querySelectorAll('li').forEach((li) => {
        const text = li.textContent.toLowerCase().replace(/\s+/g, ' ');
        li.hidden = q !== '' && !text.includes(q);
      });
    });
  }

  function init() {
    document.querySelectorAll('input[data-facet-search-target]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
